import Popup from "components/Popup";
import notifyUser from "methods/notifyUser";
import { useRef, useEffect } from "react";
import { connect } from "react-redux";
import SignaturePad from 'react-signature-canvas';
import { useMediaQuery } from "@mui/material";
import { mobileMaxWidthMediaQuery } from "../../methods/utils";

type Props = {
    close: () => void;
    onSave: (signature: string) => void;
}

let SignaturePopup: any = function SignaturePopup({ close, onSave }: Props) {
    const sigPad = useRef<any>();
    const mobile = useMediaQuery(mobileMaxWidthMediaQuery);

    useEffect(() => {
        if (mobile) {
            const scrollEl = document.querySelector(".popup__scroll");
            if (scrollEl) scrollEl.scrollTop = 0;
        }
    }, [mobile]);

    const clear = () => {
        sigPad.current.clear();
    }
    
    const save = () => {
        if (sigPad.current.isEmpty()) {
            notifyUser(null, "Пожалуйста, оставьте подпись");
            return;
        }
        const signature = sigPad.current.toDataURL();
        onSave(signature);
        close();
    }

    return (
        <Popup
            onClose={close}
            wrapperClassName={mobile ? "signaturePopup-wrapper" : undefined}
            wrapperStyle={mobile ? { height: "auto", maxHeight: "100%" } : undefined}
        >
            <div className="signaturePopup">
                <div className="commonTitle signaturePopup__title">
                    Оставьте вашу подпись
                </div>
                <div className="signaturePopup__canvasWrap">
                    <SignaturePad
                        ref={sigPad}
                        penColor='#000F55'
                        canvasProps={{
                            className: "signaturePad signaturePopup__canvas",
                            style: {
                                width: '100%',
                                height: '100%'
                            }
                        }}
                    />
                </div>
                <div className="buttonsContainer signaturePopup__buttons">
                    <button 
                        className="new withTitle secondary _wa" 
                        onClick={clear}
                    >
                        Очистить
                    </button>
                    <button 
                        className="new withTitle _wa" 
                        onClick={save}
                    >
                        Сохранить
                    </button>
                </div>
            </div>
        </Popup>
    );
}

SignaturePopup = connect(
    (store) => ({ $store: store }),
    (dispatch) => ({
        $commitToStore: (data: any) => dispatch({ ...data, type: 'S' })
    })
)(SignaturePopup)

export {SignaturePopup}